module.exports = __webpack_public_path__ + "img/edit2_b.eddf34ab.svg";